import React from "react";
import { Spinner } from "./Spinner";
import { Box } from "~/native-ui/native-base";

export class PageSpinner extends React.PureComponent {
    render() {
        return (
            <Box mt={ 50 } mb={ 50 }>
                <Spinner />
            </Box>
        )
    }
}